import IconButton from '@mui/joy/IconButton'
import DifferenceOutlinedIcon from '@mui/icons-material/DifferenceOutlined'
import CircularProgress from '@mui/material/CircularProgress'

export const DuplicateButton = ({ onClick, isPending }) => (
    <IconButton variant="outlined" color="primary" onClick={onClick}>
        {isPending ? (
            <CircularProgress size="1rem" />
        ) : (
            <DifferenceOutlinedIcon />
        )}
    </IconButton>
)
